export default function invariant(
  condition: boolean,
  message?: string,
  ErrorType: new (message?: string) => Error = Error,
): asserts condition {
  if (!condition) {
    throw new ErrorType(message);
  }
}
